var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as fromStore from '../../_store';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ValidatorsApp } from '@ibe.components/shared/_validators';
import * as fromGlobalStore from '@ibe/store/index';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var PassengerDetailEmergencyContactComponent = /** @class */ (function () {
    function PassengerDetailEmergencyContactComponent(fb, store, globalStore, router, ibeAdminService) {
        this.fb = fb;
        this.store = store;
        this.globalStore = globalStore;
        this.router = router;
        this.ibeAdminService = ibeAdminService;
        this.displayValidationMessages = false;
        this.form = this.fb.group({
            emName: [null, [Validators.required, ValidatorsApp.no_whitespace, Validators.pattern('[a-zA-Z_ ]+'), Validators.maxLength(51)]],
            emPrefix: [null, [Validators.required]],
            emPhone: [null, [Validators.required, Validators.pattern('[0-9]+'), Validators.maxLength(11)]],
            declined: [null],
            emCountry: [null, [Validators.required]]
        });
        this.isBookingPaymentPage = false;
        this.sub$ = new Subscription();
        this._hasChanges = new BehaviorSubject(false);
        this.countryCodesCodeOpts = [];
        this.countryCodesPrefixOpts = [];
    }
    PassengerDetailEmergencyContactComponent.prototype.trackByFn = function (index, item) {
        return index;
    };
    Object.defineProperty(PassengerDetailEmergencyContactComponent.prototype, "formClassDisplayModeView", {
        get: function () {
            return Object.is(this.displayMode, 'view') ? 'sidebar__form--view-only' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailEmergencyContactComponent.prototype, "countryClassOnError", {
        get: function () {
            return this.form.get('emCountry').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailEmergencyContactComponent.prototype, "prefixClassOnError", {
        get: function () {
            return this.form.get('emPrefix').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailEmergencyContactComponent.prototype, "nameClassOnError", {
        get: function () {
            return this.form.get('emName').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailEmergencyContactComponent.prototype, "hasChanges", {
        get: function () {
            return this._hasChanges.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailEmergencyContactComponent.prototype, "hasData", {
        get: function () {
            return !_.isEmpty(this.form.value);
        },
        enumerable: true,
        configurable: true
    });
    PassengerDetailEmergencyContactComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think/payment')) {
            this.isBookingPaymentPage = true;
        }
        this.sub$.add(this.store.select(fromStore.getSelectedEmergencyData)
            .subscribe(function (data) {
            _this.fillFormWithStoreData(data);
        }));
        this.sub$.add(this.globalStore.select(fromGlobalStore.getSelectedCountryCodesOpts)
            .subscribe(function (data) {
            if (data && data.length) {
                _this.countryCodesCodeOpts = _this.INDRA_getCountryCodesOptions(data);
            }
        }));
        this.sub$.add(this.globalStore.select(fromGlobalStore.getSelectedCountryCodesPrefixOpts)
            .subscribe(function (data) {
            if (data && data.length) {
                _this.countryCodesPrefixOpts = _this.INDRA_getCountryCodesOptionsPrefix(data);
            }
        }));
        this.form.valueChanges.subscribe(function () {
            _this._hasChanges.next(true);
            _this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateEmergencyContact': true }));
        });
        this.sub$.add(this.form.get('declined').valueChanges.subscribe(function (newValue) {
            if (newValue) {
                _this.setFormValidatorsWhenDeclined();
            }
            else {
                _this.setFormValidatorsWhenNotDeclined();
            }
        }));
        // dispatch by default since this is a required section
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateEmergencyContact': true }));
    };
    PassengerDetailEmergencyContactComponent.prototype.fillFormWithStoreData = function (data) {
        if (!_.isNil(data)) {
            this.form.patchValue(this.getFormObject(data), { emitEvent: false });
            this.displayMode = this.isBookingPaymentPage ? 'edit' : 'view';
        }
        else {
            this.displayMode = 'edit';
        }
        if (data && data.declined) {
            this.setFormValidatorsWhenDeclined();
        }
        else {
            this.setFormValidatorsWhenNotDeclined();
        }
    };
    PassengerDetailEmergencyContactComponent.prototype.getFormObject = function (data) {
        return __assign({}, data, { emName: !_.isNil(data.emSurname) ? ((data.emName || '') + ' ' + (data.emSurname || '')).trim() : (this.isBookingPaymentPage ? (data.emName || '').trim() : null), emPrefix: this.mapPrefixData(data.emPrefix) });
    };
    PassengerDetailEmergencyContactComponent.prototype.mapPrefixData = function (emPrefix) {
        if (!_.isNil(emPrefix)) {
            return Object.is('+', emPrefix.charAt(0)) ? emPrefix : '+' + emPrefix;
        }
        else {
            return null;
        }
    };
    PassengerDetailEmergencyContactComponent.prototype.setFormValidatorsWhenDeclined = function () {
        this.form.get('emCountry').clearValidators();
        this.form.get('emName').clearValidators();
        this.form.get('emPrefix').clearValidators();
        this.form.get('emPhone').clearValidators();
        this.form.get('emCountry').updateValueAndValidity({ emitEvent: false });
        this.form.get('emName').updateValueAndValidity({ emitEvent: false });
        this.form.get('emPrefix').updateValueAndValidity({ emitEvent: false });
        this.form.get('emPhone').updateValueAndValidity({ emitEvent: false });
    };
    PassengerDetailEmergencyContactComponent.prototype.setFormValidatorsWhenNotDeclined = function () {
        this.form.get('emCountry').setValidators([Validators.required]);
        this.form.get('emName').setValidators([Validators.required, ValidatorsApp.no_whitespace, Validators.pattern('[a-zA-Z_ ]+'), Validators.maxLength(51)]);
        this.form.get('emPrefix').setValidators(Validators.required);
        this.form.get('emPhone').setValidators([Validators.required, Validators.pattern('[0-9]+'), Validators.maxLength(11)]);
        this.form.get('emCountry').updateValueAndValidity({ emitEvent: false });
        this.form.get('emName').updateValueAndValidity({ emitEvent: false });
        this.form.get('emPrefix').updateValueAndValidity({ emitEvent: false });
        this.form.get('emPhone').updateValueAndValidity({ emitEvent: false });
    };
    PassengerDetailEmergencyContactComponent.prototype.INDRA_getCountryCodesOptions = function (countryCodes) {
        var _this = this;
        var options = countryCodes.map(function (item) { return ({
            value: item.value,
            text: _this.INDRA_getTranslation(item.text)
        }); });
        options.sort(function (a, b) { return a.text.localeCompare(b.text); });
        return options;
    };
    PassengerDetailEmergencyContactComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    PassengerDetailEmergencyContactComponent.prototype.ngOnDestroy = function () {
        this.sub$.unsubscribe();
    };
    PassengerDetailEmergencyContactComponent.prototype.formEmergencyContactErrors = function (control) {
        var errors = [];
        if (Object.is(control, 'emName')) {
            if (this.form.controls[control].hasError('whitespace')
                || this.form.controls[control].hasError('pattern')) {
                errors.push('bookingDetails.error.emergencyContactNameInvalid');
            }
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.emergencyContactNameRequired');
            }
            if (this.form.controls[control].hasError('maxlength')) {
                errors.push("Emergency Contact name can't have more than 51 characters");
            }
        }
        if (Object.is(control, 'emCountry')) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.emergencyContactCountryRequired');
            }
        }
        if (Object.is(control, 'emPrefix')) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.emergencyContactPhoneCountryCodeRequired');
            }
        }
        if (Object.is(control, 'emPhone')) {
            if (this.form.controls[control].hasError('pattern')) {
                errors.push('bookingDetails.error.emergencyContactPhoneNumberInvalid');
            }
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.emergencyContactPhoneNumberRequired');
            }
            if (this.form.controls[control].hasError('maxlength')) {
                errors.push("Emergency Phone number can't have more than 11 digits");
            }
        }
        return errors.join('; ');
    };
    PassengerDetailEmergencyContactComponent.prototype.cancelEdit = function () {
        var _this = this;
        this.store.select(fromStore.getSelectedEmergencyData)
            .pipe(take(1))
            .subscribe(function (data) {
            if (!_.isNil(data)) {
                _this.form.reset(_this.getFormObject(data), { emitEvent: false });
            }
            else {
                _this.form.reset();
            }
        });
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateEmergencyContact': false }));
        this.displayMode = 'view';
        this._hasChanges.next(false);
    };
    PassengerDetailEmergencyContactComponent.prototype.openEditForm = function () {
        this.displayMode = 'edit';
    };
    PassengerDetailEmergencyContactComponent.prototype.clearForm = function () {
        this.form.reset();
    };
    PassengerDetailEmergencyContactComponent.prototype.INDRA_getCountryCodesOptionsPrefix = function (countryCodes) {
        var _this = this;
        var options = countryCodes.map(function (item) { return ({
            value: item.value,
            text: _this.INDRA_getTranslation(item.text) + ' ' + item.value
        }); });
        options.sort(function (a, b) { return a.text.localeCompare(b.text); });
        return options;
    };
    return PassengerDetailEmergencyContactComponent;
}());
export { PassengerDetailEmergencyContactComponent };
